import { useCallback } from 'react'
import {
  useAppliedPaypayPoints,
  useChangePayPayPointsUsage,
  useToggleAllPayPayPointsSelected,
} from '../../store/payment'
import {
  useIsAllPayPayPointSelected,
  useIsPayPayPointEnabled,
} from '../../store/stateMachine/context'

export function useInput() {
  const usage = useAppliedPaypayPoints()
  const enabled = useIsPayPayPointEnabled()
  const changePayPayPointUsage = useChangePayPayPointsUsage()
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      changePayPayPointUsage(e.target.value)
    },
    [changePayPayPointUsage]
  )
  const toggle = useToggleAllPayPayPointsSelected()
  const checked = useIsAllPayPayPointSelected()
  const onCheck = useCallback(
    (_: React.ChangeEvent<HTMLInputElement>) => {
      toggle()
    },
    [toggle]
  )
  return { usage, onChange, onCheck, checked, enabled }
}
